import { Text } from "~/components/Text"
import { Outlet, useLocation, useNavigate } from "react-router"
import { Flex, Layout, Menu, Typography } from "antd"
import type { MenuProps } from "antd"
import { ROUTER } from "~/common/router"
import { STAFF_PAGES } from "~/pages/Staff/routes"
import styles from "./index.css"

const { Title } = Typography

const staffMenuItems: MenuProps["items"] = STAFF_PAGES.flatMap(
  ({ path, menu }) => (menu ? [{ key: path, ...menu }] : []),
)

const staffMenuKeys = STAFF_PAGES.filter(({ menu }) => menu).map(
  ({ path }) => path,
)

export const StaffLayout = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const selectedKey =
    staffMenuKeys.find((key) => location.pathname === key) || ROUTER.STAFF_GIFT

  return (
    <Layout className={styles.layout}>
      <Layout.Header className={styles.header}>
        <Flex
          align="center"
          justify="space-between"
        >
          <Flex
            align="center"
            gap={12}
          >
            <Text
              size={18}
              color="var(--ant-color-text-light-solid)"
              className={styles.logoMark}
            >
              咔
            </Text>
            <Flex>
              <Title level={4}>咔嗒爆 Staff</Title>
            </Flex>
          </Flex>
        </Flex>
      </Layout.Header>
      <Layout className={styles.body}>
        <Layout.Sider className={styles.sider}>
          <Menu
            mode="inline"
            items={staffMenuItems}
            selectedKeys={[selectedKey]}
            onClick={({ key }) => navigate(key)}
          />
        </Layout.Sider>
        <Layout.Content className={styles.content}>
          <Outlet />
        </Layout.Content>
      </Layout>
    </Layout>
  )
}
